import React, { useState, useEffect } from "react";
import StaffProfileCard from "../../Staff/partials/StaffProfileCard";
import LinkButton from "../../../partials/Buttons/LinkButton";
import PrimaryButton from "../../../partials/Buttons/PrimaryButton";
import { toast } from "react-toastify";
import { useMutation } from "react-apollo";
import { UPDATE_OBS, UPDATE_SECTION } from "../../../queries/patient.query";
import { CleanMessage } from "../../../util/app";
import LoadingSpinner from "../../../partials/loading";

import { EventEmitter } from "../../../event/EventEmitter";
import { EVENT_TARGET } from "../../../event/model";

const PatientProfileCard = ({ patient, className }) => {
  const [emergency, setEmergency] = useState(undefined);

  const [updateOBS, { loading }] = useMutation(UPDATE_OBS, {
    onError: (e) => toast.error(CleanMessage(e.message)),
    onCompleted: (d) => {
      if (d.UpdateObservation) {
        toast.success(d.UpdateObservation.message);
      }
    },
  });
  useEffect(() => {
    if (patient) setEmergency(patient.emergency_contact);
  }, [patient, setEmergency]);

  const [updateSectionFunc, { loading: sLoading }] = useMutation(
    UPDATE_SECTION,
    {
      onError: (e) => toast.error(CleanMessage(e.message)),
      onCompleted: (d) => {
        if (d.UpdateSection) {
          toast.success(d.UpdateSection.message);
        }
      },
    }
  );

  const onScroll = () => {
    window.document.body.scrollTop = 0;
    window.document.documentElement.scrollTop = 0;
  };

  if (!patient) return null;
  const _profileLink = "/home/patient/profile";

  EventEmitter.subscribe(EVENT_TARGET.Emergency, (event) =>
    setEmergency(event)
  );

  return (
    <>
      <center className={className}>
        <small className="text-muted">Date of Birth</small> <br />
        <strong>
          {new Intl.DateTimeFormat("en-GB", {
            month: "long",
            day: "2-digit",
            year: "numeric",
          }).format(new Date(patient.dob))}
        </strong>
        <hr />
      </center>
      <center>
        <small className="text-muted">CSN</small> <br />
        <strong>{patient.hcn}</strong>
        <hr />
        <small className="text-muted">Gender</small> <br />
        <strong>{patient.gender}</strong>
        <hr />
        <small>Hospital Name</small> <br />
        <strong>{patient.site.name}</strong>
        <hr />
        <small>OBS Level</small>
        <br />
        <strong>{patient.observation || "None"} </strong>
      </center>
      <div className="text-right">
        <PrimaryButton
          onClick={async () => {
            const name = window.prompt("Enter Patient OBS Level:");
            if (name) {
              await updateOBS({
                variables: { id: patient.id, observation: name },
              });
            }
          }}
        />
      </div>
      <LoadingSpinner loading={loading} bar={true} />
      <hr />
      <center>
        <small>Section Status</small>
        <br />
        <strong>{patient.section || "None"}</strong>
      </center>
      <div className="text-right">
        <PrimaryButton
          onClick={async () => {
            const name = window.prompt("Enter Patient Section Status:");
            if (name) {
              await updateSectionFunc({
                variables: { id: patient.id, section: name },
              });
            }
          }}
        />
      </div>
      <LoadingSpinner loading={sLoading} bar={true} />
      <hr />
      <center>
        <small>Primary Nurse</small>
        <br />
        {patient.primary_nurse ? (
          <StaffProfileCard item={patient.primary_nurse} />
        ) : (
          <>
            <strong className="text-warning">No Primary Nurse Yet</strong>
          </>
        )}
      </center>
      <div className="text-right">
        <LinkButton
          onScroll={onScroll}
          to={`${_profileLink}/${patient.id}/update-nurse`}
        />
      </div>
      <hr />
      <center>
        <small>Doctor</small>
        <br />
        {patient.doctor ? (
          <StaffProfileCard item={patient.doctor} />
        ) : (
          <>
            <strong className="text-warning">No Personal Doctor Yet</strong>
          </>
        )}
      </center>
      <div className="text-right">
        <LinkButton
          onClick={onScroll}
          to={`${_profileLink}/${patient.id}/update-doctor`}
        />
      </div>
      <hr />
      <center>
        <small>Psychiatrist </small> <br />
        {patient.psychiatrist ? (
          <StaffProfileCard item={patient.psychiatrist} />
        ) : (
          <>
            <strong className="text-warning">No Psychiatrist Yet</strong>
          </>
        )}
      </center>
      <div className="text-right">
        <LinkButton
          onClick={onScroll}
          to={`${_profileLink}/${patient.id}/update-psychiatrist`}
        />
      </div>
      {emergency && (
        <div>
          <h4 className="text-primary">Emergency Contact</h4>
          <table className="table table-bordered">
            <tbody>
              <tr>
                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                  <strong>Name</strong>
                </td>
                <td>{emergency.name}</td>
              </tr>
              <tr>
                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                  <strong>Phone No</strong>
                </td>
                <td>{emergency.mobile}</td>
              </tr>
              <tr>
                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                  <strong>Relation to Patient</strong>
                </td>
                <td>{emergency.relationship}</td>
              </tr>
              <tr>
                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                  <strong>Address</strong>
                </td>
                <td>{emergency.address}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {!emergency && (
        <div className="text-left fade-in">
          <hr />
          <h5>Emergency Contact</h5>
          <LinkButton
            onClick={onScroll}
            to={`${_profileLink}/${patient.id}/update-emergency`}
          />
          <hr />
        </div>
      )}
    </>
  );
};

export default PatientProfileCard;
